module.exports = __webpack_public_path__ + "static/media/freedom_inner_circle_vault.01d2a504.jpg";